import { api } from "../api/api";

const errorHandler = (error) => {
  if (error?.code?.trim() === "ERR_NETWORK") {
    throw new Error(
      "It looks like we can't reach the server right now. Please try refreshing the page or check after sometime."
    );
  } else {
    throw new Error(error?.response?.data?.title);
  }
};

export const getFileResourceData = async () => {
  try {
    const response = await api.get(`/api/PurchaseOrder/file-sources`);
    return response.data?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};

export const getMessageTypeData = async () => {
  try {
    const response = await api.get(`/api/Edial/message-types`);
    return response?.data?.result?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};

export const getRestagingData = async (formData) => {
  try {
    const response = await api.post(
      `/api/Edial/restagable-orders/search`,
      formData
    );
    return response?.data?.result?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};

export const postRestageOrders = async (ids) => {
  try {
    const response = await api.post(
      `/api/Edial/restagable-orders/restage`,
      ids
    );
    return response?.data?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};

export const exportRestageOrders = async (formbody) => {
  const token = localStorage.getItem("token");
  const downloadUrl = `${process.env.REACT_APP_BASE_URL}/api/Edial/restagable-orders/export`;
  try {
    const response = await fetch(downloadUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(formbody)
    });
    if (!response.ok) {
      throw new Error(`Export failed with status ${response.status}`);
    }
    const contentType = response.headers.get("Content-Type");
    if (contentType && contentType.includes("application/")) {
      const disposition = response.headers.get("Content-Disposition");
      let fileName = "RestagableOrders.xlsx";
      if (disposition) {
        const match = /filename\*?=(?:UTF-8'')?"?([^;"]+)"?/i.exec(disposition);
        if (match && match[1]) {
          fileName = decodeURIComponent(match[1]);
        }
      }
      const blob = await response.blob();
      const fileUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(fileUrl);
    } else {
      throw new Error("The response is not a valid file type.");
    }
  } catch (error) {
    errorHandler(error);
  }
};
